import { render, staticRenderFns } from "./intro-footer.vue?vue&type=template&id=da6b66d6&scoped=true&"
import script from "./intro-footer.vue?vue&type=script&lang=js&"
export * from "./intro-footer.vue?vue&type=script&lang=js&"
import style0 from "./intro-footer.vue?vue&type=style&index=0&id=da6b66d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b66d6",
  null
  
)

export default component.exports